export const IBillingSessionCustomer = Object.freeze({
  id: "id",
  firstname: "firstname",
  lastname: "lastname",
  company: "company_name",
  boLink: "bo_link",
  stripeLink: "stripe_link",
});

export class BillingSessionCustomerModel {
  constructor(data = {}) {
    this[IBillingSessionCustomer.id] = data[IBillingSessionCustomer.id];
    this[IBillingSessionCustomer.firstname] = data[IBillingSessionCustomer.firstname];
    this[IBillingSessionCustomer.lastname] = data[IBillingSessionCustomer.lastname];
    this[IBillingSessionCustomer.company] = data[IBillingSessionCustomer.company];
    this[IBillingSessionCustomer.boLink] = data[IBillingSessionCustomer.boLink];
    this[IBillingSessionCustomer.stripeLink] = data[IBillingSessionCustomer.stripeLink];
  }

  getId() {
    return this[IBillingSessionCustomer.id];
  }

  getFirstname() {
    return this[IBillingSessionCustomer.firstname] || "";
  }

  getLastname() {
    return this[IBillingSessionCustomer.lastname] || "";
  }

  getFullname() {
    return `${this.getFirstname()} ${this.getLastname()}`;
  }

  getCompany() {
    return this[IBillingSessionCustomer.company];
  }

  getBackofficeLink() {
    return this[IBillingSessionCustomer.boLink];
  }

  getStripeLink() {
    return this[IBillingSessionCustomer.stripeLink];
  }
}
